import TranslationText from '@Components/Utilities/TranslationText';

const RelevantPartsLink = (props) => {
    return (
        props.RelevantPartsLink && props.RelevantPartsLink != '' ?
            <div className='blog-seo no-print'>
                <h3><TranslationText tKey='sandhills.tradepubwebsite.mvc.lookingforparts' /></h3>
                <div className='blog-post'>
                    <a href={props.RelevantPartsLink}>{props.RelevantPartsTitle}</a>
                </div>
            </div>
        : <></>
    )
};

export default RelevantPartsLink;